// import fetch from './fetch-json.js'
import request from './request.js';
import fetch from './fetch-file.js';

export function getCampaigns(data) {
  return request({
    url: 'emailmarketing/getData',
    method: 'post',
    params: data,
  });
}

export function createNewCampaign(data) {
  return request({
    url: 'emailmarketing/insert',
    method: 'post',
    params: data,
  });
}

export function updateCampaign(data) {
  return request({
    url: 'emailmarketing/update',
    method: 'post',
    params: data,
  });
}

export function archiveCampaign(data) {
  return request({
    url: 'emailmarketing/archive',
    method: 'post',
    params: data,
  });
}

export function unarchiveCampaign(data) {
  return request({
    url: 'emailmarketing/unarchive',
    method: 'post',
    params: data,
  });
}

export function scheduleCampaign(data) {
  return request({
    url: 'emailmarketing/schedule',
    method: 'post',
    params: data,
  });
}

export function cancelScheduleCampaign(data) {
  return request({
    url: 'emailmarketing/cancelSchedule',
    method: 'post',
    params: data,
  });
}

export function deleteCampaign(data) {
  return request({
    url: 'emailmarketing/delete',
    method: 'post',
    params: data,
  });
}

export function sendCampaign(data) {
  return request({
    url: 'emailmarketing/send',
    method: 'post',
    params: data,
  });
}

export function getCompaignProjects(data) {
  return request({
    url: 'project/getDataForEmailMarketing',
    method: 'post',
    params: data,
  });
}

export function getCompaignOneData(data) {
  return request({
    url: 'emailmarketing/getOneData',
    method: 'post',
    params: data,
  });
}

//获取campaign客户列表
export function getCompaignContacts(data) {
  return request({
    url: 'emailmarketingcontact/getAllDataByProject',
    method: 'post',
    params: data,
  });
}

//上传文件
export function uploadFile(data) {
  return request({
    url: 'emailmarketing/uploadFile',
    method: 'post',
    params: data,
  });
}

//send test email
export function sendTestEmail(data) {
  return request({
    url: 'emailmarketing/testFormat',
    method: 'post',
    params: data,
  });
}

//上传略缩图
export function uploadThumbnail(data) {
  return fetch({
    url: 'emailmarketing/uploadThumbnail',
    method: 'post',
    data: data,
  });
}

//上传picture
export function uploadPicture(data) {
  return fetch({
    url: 'emailmarketing/uploadFile',
    method: 'post',
    data: data,
  });
}

//获取待选的项目图片列表
export function getAllPictures(data) {
  return request({
    url: 'emailmarketingproject/getAllPictures',
    method: 'post',
    params: data,
  });
}

//获取待选的项目房源列表
export function getAllProperties(data) {
  return request({
    url: 'emailmarketingproject/getAllProperties',
    method: 'post',
    params: data,
  });
}

//获取待选的项目附件列表
export function getAllAttachments(data) {
  return request({
    url: 'emailmarketingproject/getAllAttachments',
    method: 'post',
    params: data,
  });
}

//获取活动邮件的送信日志 - contact
export function getContactLogData(data) {
  return request({
    url: 'emailmarketing/getContactLogData',
    method: 'post',
    params: data,
  });
}

//获取活动邮件所有 recipient type 的数量
export function getSummaryLogCount(data) {
  return request({
    url: 'emailmarketing/getSummaryLogCount',
    method: 'post',
    params: data,
  });
}

//获取活动邮件的各operatetype的数量 - contact
export function getContactLogCount(data) {
  return request({
    url: 'emailmarketing/getContactLogCount',
    method: 'post',
    params: data,
  });
}

//获取活动邮件的送信日志 - agent
export function getAgentLogData(data) {
  return request({
    url: 'emailmarketing/getAgentLogData',
    method: 'post',
    params: data,
  });
}

//获取活动邮件的各operatetype的数量 - agent
export function getAgentLogCount(data) {
  return request({
    url: 'emailmarketing/getAgentLogCount',
    method: 'post',
    params: data,
  });
}

//获取活动邮件的送信日志 - external teams
export function getExternalTeamLogData(data) {
  return request({
    url: 'emailmarketing/getChannelLogData',
    method: 'post',
    params: data,
  });
}

//获取活动邮件的各operatetype的数量 - external teams
export function getExternalTeamLogCount(data) {
  return request({
    url: 'emailmarketing/getChannelLogCount',
    method: 'post',
    params: data,
  });
}

export function getUsageData(data) {
  return request({
    url: 'emailmarketing/getUsageData',
    method: 'post',
    params: data,
  });
}

export function getLimitData(data) {
  return request({
    url: 'emailmarketing/getLimitData',
    method: 'post',
    params: data,
  });
}

export function saveLimitData(data) {
  return request({
    url: 'emailmarketing/saveLimitData',
    method: 'post',
    params: data,
  });
}

export function copyCampaign(data) {
  return request({
    url: 'emailmarketing/copy',
    method: 'post',
    params: data,
  });
}

export function getReportData(data) {
  return request({
    url: 'emailmarketing/getReportData',
    method: 'post',
    params: data,
  });
}

export function downloadReportCsv(data) {
  return request({
    url: 'emailmarketing/downloadReportCsv',
    method: 'post',
    params: data,
  });
}

export function downloadActivityCsv(data) {
  return request({
    url: 'emailMarketing/downloadActivityCsv',
    method: 'get',
    params: data,
  });
}




// WEBPACK FOOTER //
// ./src/api/campaignApi.js